var _rect, _rect2, _rect3, _rect4, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDept = function SvgDept(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 4,
    x: 18,
    y: 16,
    fill: "#7C7C7C",
    rx: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 4,
    x: 10,
    y: 16,
    fill: "#7C7C7C",
    rx: 2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6,
    x: 9,
    y: 3,
    fill: "#7C7C7C",
    rx: 3
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 4,
    x: 2,
    y: 16,
    fill: "#7C7C7C",
    rx: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#7C7C7C",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M12 6v6m0 6v-6m0 0H4v6m8-6h8v6"
  })));
};
export { SvgDept as ReactComponent };
export default __webpack_public_path__ + "96116d3a8997a71de5cbfd4c4e3c6593.svg";